import * as Config from '../../../config';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from "react-router-dom";
import dayjs from 'dayjs';
import './Playlist.css';

import ListV2 from '../content/list/ListV2';
import Card from '../common/Card';
import Spinner from '../common/Spinner';
import JoinLinkage from '../common/JoinLinkage';
import Linkage from '../common/Linkage';
import DelayButton from '../common/DelayButton';
import AutomixToggleButton from '../automix/AutomixToggleButton';
import ActionFilters from './ActionFilters';
import ButtonEditor from '../touch/ButtonEditor';
import ButtonPlaylistCart from '../cart/ButtonPlaylistCart';
import ButtonsPlaylistEdit from './ButtonsPlaylistEdit';

import useGetOne from '../../../hooks/useGetOne';
import usePlaylist from '../../../hooks/usePlaylist';
import useCartPlaylist from '../cart/hooks/useCartPlaylist';

import { connect } from "react-redux";
import {
  setStateClearFilters,
  addToast
} from "../../../actions/index";

// Entrypoint for all kind of playlists
function ConnectedPlaylist({
  style, path = null, data = null, name = null, track_count = null, key = null, covers = null, fromDJ = null,
  type, propertyUpdatedDate, propertyCreatedDate, buttonLabel = `Save playlist`, showDNav = true,
  api, user, dimension,
  setStateClearFilters, addToast,
  isConnected, enableActionsButton, isScrolling, isDnavOpen, storePopup, storePlaylists,
  touchEditor, isLimited = false,
  length_ms = null
}) {
  const { item } = useGetOne(api, path, data);
  const { width, height } = dimension;

  const globalHistory = useHistory();
  if (!path && !data) { globalHistory.push(`/`) }

  const {
    beginDrag,
    activeFilters,
    showFilters,
    clearFilters,
  } = usePlaylist(item, path, type);

  const images = (item)
    ? ( (covers)
      ? covers
      : ( (path)
        ? ( (item.release_images && item.release_images.length > 0)  ? item.release_images : [(item.image && item.image.uri !== Config.DEFAULT_IMG) ? item.image.uri : ( (item.person && item.person.owner_image) ? item.person.owner_image : Config.DEFAULT_IMG)] )
        : ( (data && data.tracks.length > 0) ? [...data.tracks.map( x => x.img )] : [Config.DEFAULT_IMG] )
        )
      )
    : null;

  const directCopy = () => {
    if (path) {
      if (enableActionsButton) {
        const nbTracks = (item.track_count) ? item.track_count : 100;
        api.getFromApi(`${path}/tracks/?per_page=${nbTracks}`, false).then( response => {

          const playlistName = (name) ? name : item.name;
          const extra = {
            covers: (type === 'charts' && images) ? [images[0]] : null,
            fromDJ: (type === 'charts' && item.person) ? item.person.owner_name : null,
            fromDJID: (type === 'charts' && item.person) ? item.person.id : null
          }
          const data = [...response.data.results.map(Config.formattedFromBP)];
          const next = response.data.next;
          const previews = data.filter( x => x.is_available_for_streaming === false );
          const selection = data.filter( x => x.is_available_for_streaming === true );
          storePlaylists.new(playlistName, selection, extra, next);
          addToast({ content: <span>Playlist '{playlistName}' saved.</span>, typeClass: 'success', iconStyle: { padding: 16, marginRight: 16 } });
          if (previews.length > 0) {
            addToast({ content: <span>{previews.length} track(s) not added to '{playlistName}'. Download only, full-track streaming is unavailable.</span>, typeClass: 'warning', iconStyle: { padding: '32px 16px', marginRight: 16 } });
          }
          if (isConnected) { //Reporting
            const dataEvent = selection.map( x => {
              const source_item_type = (type === 'charts') ? `Playlist` : `Release`;
              const source_item_id = item.id;
              return { track_id: x.id, source_item_type, source_item_id }
            } );
            storePlaylists.report(`/events/save-to-library/`, dataEvent);
          }

        } ).catch( e => console.log(`error`, e) );
      } else {
        storePopup.playlist('.playlist-button-save'); //storeAuth.link();
      }
    }
  }


  const { addPlaylistToCart } = useCartPlaylist(path, type);

  const [force, setForce] = useState(false);
  useEffect( () => {
    setForce(false);
    setStateClearFilters(false);
  }, [item, setStateClearFilters])
  const bestHeight = () => {
    let recommandHeight = (isLimited) ? (item.track_count < 2 ? Config.LIST_ROW_HEIGHT * item.track_count :  Config.LIST_ROW_HEIGHT * 2) : height - 160;
    recommandHeight += (isScrolling || force) ? 55 : 0;
    recommandHeight -= (isDnavOpen) ? 112 : 0;
    const diff = (Config.LIST_ROW_HEIGHT * ((track_count) ? track_count : item.track_count)) - recommandHeight;
    if (diff > Config.LIST_ROW_HEIGHT / 2 && diff < Config.LIST_ROW_HEIGHT && !force && !isScrolling) {
      setForce(true)
    }
    return recommandHeight;
  }
  const enableScrolling = false;
  const enableDuration = (length_ms || (item && item.length_ms));

  return (!item)
    ? <Spinner />
    : (
      <div className={`flexColumn playlist-page ${enableScrolling && `scrolling`}`} style={{ ...style }}>
        <div className={`flexRow card-container-playlist ${enableScrolling && `scrolling`}`}>
          <Card
            images={images}
            audio={{
              id: item.id,
              name: (name) ? name : item.name,
              tracks: track_count,
              showDNav: showDNav,
              extra: (type === `charts`) ? {
                covers: (images) ? [images[0]] : null,
                fromDJ: (item.person) ? item.person.owner_name : null,
                fromDJID: (item.person) ? item.person.id : null
              } : null
            }}
            dragEnabled={true}
            playEnabled={true}
            beginDrag={beginDrag}
            type={(data) ? `PLAYLIST` : `CHART`}
            style={{width: Config.PLAYLIST_COVER_SIZE }}
            ooWidth={Config.PLAYLIST_COVER_SIZE}
          />
          <div className={`playlist-infos flexRow space-between`}>
            
            <div className={'flexColumn f-center'}>
              <p className={`playlist-title type-title`}>{(name) ? Config.camelCase(name) : Config.camelCase(item.name)}</p>
              <p className={`playlist-p type-small`}>
                { (type === `playlists` && !fromDJ) && (user ? user.name : `Anonymous User`) }
                { type === `charts` && ( item.artist
                  ? ( item.artist.name.toLowerCase().includes(Config.API_NAME) ? item.artist.name : <JoinLinkage label={`${item.artist.name}`} separator={``} to={`/artists/${item.artist.slug}/${item.artist.id}`} className={`link-enable`} /> )
                  : (item.person ? item.person.owner_name : null)
                )}
                { (type === `releases` && item.artists) && item.artists.slice(0,10).map( (a, i) => (
                  <JoinLinkage key={a.id} label={`${a.name}`} separator={(i !== 0) ? `, ` : ``} to={`/artists/${a.slug}/${a.id}`} className={`link-enable`} />
                )) }
                { fromDJ &&  `${fromDJ}`}
                {(type === `releases`) && (
                  <>
                    <span> • </span>
                    <Linkage label={item.label.name} to={`/labels/${item.label.slug}/${item.label.id}`} linkClassName={`link-enable`} />
                  </>
                )}
                { (type === `charts` && (item.artist && item.artist.id !== 45))
                  ? ` • Created: ${dayjs(item[propertyCreatedDate]).format(`MMM DD, YYYY`)}`
                  : ` • Created: ${dayjs(item[propertyCreatedDate]).format(`MMM DD, YYYY`)} • Updated: ${dayjs(item[propertyUpdatedDate]).format(`MMM DD, YYYY`)}` 
                }    
                {` • `}{(track_count) ? track_count : item.track_count} Tracks
                {enableDuration && ` • ${Config.msToHourMin((length_ms) ? length_ms : item.length_ms)}`}
              </p>  
            </div>
            
            <div className={'flexColumn f-center'}>
              <div className={'flexRow space-between playlist-actions-container'}>
                {(type !== `playlists`) && <DelayButton
                    label={buttonLabel}
                    classNameEnable={`playlist-button-save ${Config.ACRONYME}`}
                    classNameDisable={`playlist-button-save ${Config.ACRONYME} disable`}
                    onClick={directCopy}
                /> }
                {(type === `playlists`/* && isTablet*/) && <ButtonEditor label={`Edit`} /> }
                {touchEditor && (
                  <ButtonsPlaylistEdit />
                )}
                { !touchEditor && (
                  <>
                    {type === `playlists` && <ActionFilters className={(!data && item.person) ? `chart` : `playlist`} active={activeFilters} onClick={showFilters} onClear={clearFilters} /> }
                    { path && <ButtonPlaylistCart onClick={addPlaylistToCart} />}
                    {(type !== `releases`) && <AutomixToggleButton idPlaylist={item.id} uid={item.name} className={`${(!data && item.person) ? `chart` : `myplaylist`}`} /> }
                  </>
                )}
                </div>
            </div>
            
          </div>
        </div>

        <div className={`content-container`} style={{ width }} >
          <ListV2
            id={item.id}
            name={(name) ? name : item.name}
            data={ (data) ? item.tracks : null }
            pathApi={ (path) ? `${path}/tracks/?per_page=100` : null}
            sortable={ (data || item.is_owner) ? true : false}
            width={width}
            height={ bestHeight() }
            size={Config.LIST_ROW_HEIGHT}
            style={{ marginTop: 0 }}
            filtersStyle={{ display: `none`, top: 0, right: 0 }}
            panelStyle={{ margin: `6px 0px 19px 0px` }}
            filters={[`track_name`, /*`mix_name`,*/ `artists_s`, `remixers_s`, `label`, `genre_s`, `bpm`, `key`]}
            type={(type === `playlists`) ? `Partial` : `Full#`}
            enableKeys={true}
            enableShortcuts={true}
            orderBy={[`release`, `title`, `remixers_s`, `label`, `genre_s`, `key_camelot`, `bpm`, `artists_s`]}
            isBoost={true}
            automix={false}
            from={ `/${type}/${item.id}` }
            isLoadMore={(data) ? false : true}
          />
        </div>
      </div>
    )
}

ConnectedPlaylist.propTypes = {
  type: PropTypes.string.isRequired,
  path: PropTypes.string,
  data: PropTypes.object,
  name: PropTypes.string,
  track_count: PropTypes.number,
  covers: PropTypes.array,
  fromDJ: PropTypes.string,
  propertyUpdatedDate: PropTypes.string.isRequired,
  propertyCreatedDate: PropTypes.string,
  buttonLabel: PropTypes.string,
  showDNav: PropTypes.bool,
  style: PropTypes.object,
  key: PropTypes.any
}

const Playlist = connect(
  state => ({
    api: state.api,
    isConnected: state.isConnected,
    enableActionsButton: (state.isConnected),
    user: state.user,
    dimension: state.dimension,
    isScrolling: false,
    isDnavOpen: state.DManager.toggle,
    storePopup: state.storePopup,
    storePlaylists: state.storePlaylists,
    touchEditor: state.touchEditor
   }),
  (dispatch, ownProps) => ({
    setStateClearFilters: (state) => dispatch(setStateClearFilters(state)),
    addToast: content => dispatch(addToast(content)),
  })
)(ConnectedPlaylist);

export default Playlist;
